<mat-progress-bar
	*ngIf="isLoading"
	[color]="loader.color"
	[mode]="loader.loaderType"
	[value]="loader.progress"
	[bufferValue]="loader.bufferValue"
>
</mat-progress-bar>
